import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiPhone, FiMail, FiArrowRight } = FiIcons;

const CTA = () => {
  return (
    <section className="py-20 bg-gradient-to-br from-blue-900/20 via-black to-cyan-900/20 relative overflow-hidden">
      <div className="absolute inset-0 opacity-30">
        <div className="absolute top-10 left-10 w-32 h-32 bg-blue-500/20 rounded-full blur-xl animate-pulse" />
        <div className="absolute bottom-10 right-10 w-40 h-40 bg-cyan-500/20 rounded-full blur-xl animate-pulse" />
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-60 h-60 bg-purple-500/10 rounded-full blur-2xl" />
      </div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <motion.div initial={{ opacity: 0, y: 50 }} whileInView={{ opacity: 1, y: 0 }} transition={{ duration: 0.8 }} viewport={{ once: true }} className="space-y-8">
          <motion.div initial={{ opacity: 0, scale: 0.8 }} whileInView={{ opacity: 1, scale: 1 }} transition={{ delay: 0.2 }} viewport={{ once: true }} className="inline-flex items-center space-x-2 bg-blue-600/20 border border-blue-500/30 rounded-full px-4 py-2 text-sm text-blue-300">
            <span className="w-2 h-2 bg-blue-400 rounded-full animate-pulse" /><span>Ready to Get Started?</span>
          </motion.div>

          <motion.h2 initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} transition={{ delay: 0.3 }} viewport={{ once: true }} className="text-4xl md:text-6xl font-bold">
            <span className="gradient-text">Let's Power Your</span><br /><span className="text-white">Next Project Together</span>
          </motion.h2>

          <motion.p initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} transition={{ delay: 0.4 }} viewport={{ once: true }} className="text-xl text-gray-300 max-w-3xl mx-auto leading-relaxed">
            From simple electrical repairs to complete smart home transformations, we're here to bring your vision to life with professional expertise and reliable service.
          </motion.p>

          <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} transition={{ delay: 0.5 }} viewport={{ once: true }} className="flex flex-col sm:flex-row items-center justify-center space-y-4 sm:space-y-0 sm:space-x-6">
            <Link to="/contact" className="group flex items-center space-x-3 bg-gradient-to-r from-blue-600 to-cyan-600 px-8 py-4 rounded-full text-white font-semibold text-lg hover:from-blue-700 hover:to-cyan-700 transition-all duration-300 glow-blue-strong">
              <SafeIcon icon={FiMail} className="text-lg" /><span>Get Free Quote</span><SafeIcon icon={FiArrowRight} className="text-lg group-hover:translate-x-1 transition-transform duration-300" />
            </Link>
            <a href="tel:+919906669918" className="group flex items-center space-x-3 border-2 border-white/20 px-8 py-4 rounded-full text-white font-semibold text-lg hover:border-blue-400 hover:bg-blue-400/10 transition-all duration-300">
              <SafeIcon icon={FiPhone} className="text-lg" /><span>Call: +91 99066 69918</span>
            </a>
          </motion.div>

          <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} transition={{ delay: 0.6 }} viewport={{ once: true }} className="flex flex-col sm:flex-row items-center justify-center space-y-2 sm:space-y-0 sm:space-x-8 text-sm text-gray-400">
            <div className="flex items-center space-x-2"><span className="w-2 h-2 bg-green-400 rounded-full" /><span>Free Consultation</span></div>
            <div className="flex items-center space-x-2"><span className="w-2 h-2 bg-blue-400 rounded-full" /><span>24/7 Emergency Service</span></div>
            <div className="flex items-center space-x-2"><span className="w-2 h-2 bg-purple-400 rounded-full" /><span>Licensed & Insured</span></div>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
};

export default CTA;